import * as React from "react"
import { Box, Chip } from "@mui/material"


export default function TagsBlock({list}) {
    return <Box>
        {list.map((item, index) => <Chip key={index} label={item}/>)}
    </Box>
}